import { getErrorCodeDimension } from '../dimension';

export default (metric, errorCode) => ({
  field: getErrorCodeDimension(metric),
  key: null,
  op: 'eq',
  value: errorCode,
  display: errorCode,
});

export const buildErrorRule = (metric, errorCodes) => ({
  dimension: getErrorCodeDimension(metric),
  type: 'in',
  values: errorCodes,
});
